import _ from "lodash";
export const getBilingualText = ({
  text = "",
  bilingualText,
  skipDelimiter = false,
}) => {
  const delimiterCharacter = skipDelimiter ? "" : "/";
  if (_.isEmpty(bilingualText)) {
    return text;
  } else if (_.isEmpty(text)) {
    return `${delimiterCharacter} ` + bilingualText;
  }

  return text + ` ${delimiterCharacter} ` + bilingualText;
};
